<span *ngIf="item !== undefined">
  <div [formGroup]="form">
    <div [ngSwitch]="item.controlType" class="col s12 m12 l4">

        <mat-form-field *ngSwitchCase="'textbox'" class="example-full-width" [id]="item.key">
          <span *ngIf="item.type!='date'">
            <input matInput [placeholder]="item.label" [formControlName]="item.key" [id]="item.key" [type]="item.type"
              [required]>

          </span>
          <span *ngIf="item.type=='date'">
            <input matInput [matDatepicker]="picker1" readonly [placeholder]="item.label" [attr.data-date]="item.type" [formControlName]="item.key">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </span>
          <!--<span *ngIf="item.type=='date' && item.hijoDate" >
            <input matInput  [min]="minDatePadre" [matDatepicker]="dp" readonly [attr.data-date]="item.type" (dateChange)="padre($event, 'padre', item.hijoDate)"
              [placeholder]="item.label" [formControlName]="item.key">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </span>
          <span *ngIf="item.type=='date' && item.padreDate" >
            <input  matInput [min]="minDateHijo" [matDatepicker]="picker" readonly [attr.data-date]="item.type" (dateChange)="cambio($event, 'padre', item.padreDates)" [placeholder]="item.label" class="form-control" [formControlName]="item.key">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

          </span>-->
        </mat-form-field>

        <!--<div class="form-input" *ngIf="item.type=='date' && item.hijoDate">
          <label>
            <input class="fecha-calendar" data-title="padre" [id]="item.key+'///padre'" [formControlName]="item.key" >
            <span class="placeholder">{{item.label}}</span>
          </label>
        </div>

        <div class="form-input" *ngIf="item.type=='date' && item.padreDate">
          <label>
            <input class="fecha-calendar" data-title="hijo" [id]="item.key+'///hijo'" [formControlName]="item.key" >
            <span class="placeholder">{{item.label}}</span>
          </label>
        </div>-->
      <div *ngSwitchCase="'dropdown'">
        <select [formControlName]="item.key" [id]="item.key" *ngIf="item.callback==1"
          (change)="cargaDropDown(item.origenCallBack, item.key, item.label);">
          <option value="" disabled selected>{{item.label}}</option>
          <option *ngFor="let opt of item.options" [value]="opt.key">
            {{opt.value}}
          </option>
        </select>

        <span *ngIf="!cargando"><select [formControlName]="item.key" [id]="item.key"
            *ngIf="item.callback==0 && item.depende==1">
            <option value="" disabled selected>{{item.label}}</option>
            <option *ngFor="let opt of item.options" [value]="opt.key">
              {{opt.value}}
            </option>
          </select></span>

        <select [formControlName]="item.key" [id]="item.key" *ngIf="item.callback==0 && item.depende==0">
          <option value="" disabled selected>{{item.label}}</option>
          <option *ngFor="let opt of item.options" [value]="opt.key">
            {{opt.value}}
          </option>
        </select>
        <mat-spinner [diameter]="30" *ngIf="cargando && item.callback==0 && item.depende==1"
          style="margin:0 auto; top:15px;"></mat-spinner>
      </div>
      <br>
      <span class="classError" *ngIf="!isValid && Error.maxlength !== undefined">
        Tamaño Máximo {{item.maxlength}}
      </span>
      <span class="classError" *ngIf="!isValid && Error.pattern !== undefined">
        Solo Números
      </span>
      <span class="classError" *ngIf="!isValid && Error.email !== undefined">
        Email Ej: nombre@dominio.com
      </span>
      <span class="classError" *ngIf="!isValid && Error.minlength !== undefined">
        Tamaño Mínimo {{item.minlength}}
      </span>
    </div>



  </div>
</span>
